import { logError } from '@ff-os/shared-utils/logging';
import { AppThunkApi, PdpDispatch, PdpState } from '../../store';
import { externalUploadPoller } from './externalUploaderPoller';
import { pollExternalUploads } from './pollExternalUploads';

export const tryPollExternalUploads = (
    state: PdpState,
    dispatch: PdpDispatch
) => {
    const externalUploaderCount = Object.values(state.externalUploaders.entities).length;

    if (externalUploaderCount === 0) {
        return Promise.resolve();
    }

    const lastUpdatedOn = externalUploadPoller.updatedOn ?? Date.now();

    return pollAndDispatchExternalUploads(lastUpdatedOn, { dispatch, getState: () => state });
};

const pollAndDispatchExternalUploads = async (
    lastUpdatedOn: number,
    thunkApi: AppThunkApi
) => {
    try {

        const response = await pollExternalUploads(lastUpdatedOn, thunkApi);
        externalUploadPoller.updatedOn = response.updatedOn;

        if (response.assets.length <= 0) {
            return;
        }

        for (const handler of externalUploadPoller.handlers) {
            handler(response.assets);
        }

    } catch (e) {
        logError(e);
    }
};